import TicketsComponent from "../components/TicketsComponent";
import { useEffect, useRef, useState } from "react";
import { Grid } from "../../../../../../Layout/Grid/GridView";
const TicketsStatsView = ({ data }) => {
  const gridTicketsListEntriesRef = useRef();
  return data ? (
    <div>
      <div className="row">
        <div className="mb-3 col-12 col-sm-4">
          <div className="card card-stats mb-4 mb-xl-0 cards-bg">
            <div className="card-body card-body-bg-dark box-venue">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Nº Bilhetes Vendidos
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.totalTickets}
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                    <i
                      className="fas fa-credit-card text-light"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div>
        <div className="mb-3 col-12 col-sm-4">
          <div className="card card-stats mb-4 mb-xl-0 cards-bg">
            <div className="card-body card-body-bg-dark box-venue">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Nº Transações
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.totalTransactions}
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                    <i
                      className="fas fa-money-bill-transfer text-light"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div>
        <div className="mb-3 col-12 col-sm-4">
          <div className="card card-stats bg-dark mb-4 mb-xl-0 cards-bg">
            <div className="card-body card-body-bg-dark box-venue">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Total de Vendas
                  </h5>
                  <span className="h2 font-weight-bold mb-0">{data.totalValueTickets} €</span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                    <i
                      className="fa-solid fa-money-bill text-light"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div>
        <div className="mb-3 col-12 col-sm-6">
          <div className="card card-stats mb-4 mb-xl-0 cards-bg">
            <div className="card-body card-body-bg-dark box-venue">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    CHECK-IN
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.totalTicketsCheckIn}
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                    <i
                      className="fas fa-check text-light"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div>
        <div className="mb-3 col-12 col-sm-6">
          <div className="card card-stats mb-4 mb-xl-0 cards-bg">
            <div className="card-body card-body-bg-dark box-venue">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    TAXA CHECK-IN
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.txCheckInTickets}%
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                    <i
                      className="fas fa-percent text-light"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="row mt-5"> */}
      {/* <div className="col-12 col-sm-4">
          <div className="card card-stats bg-dark mb-4 mb-xl-0 cards-bg">
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Taxa de Cancelamento
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.stats.taxSuccess}%
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                    <i
                      className="fa-solid fa-percent"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div> */}
      {/* <div className="col-12  col-sm-4">
          <div className="card card-stats bg-dark mb-4 mb-xl-0 cards-bg">
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Taxa de Conversão
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.stats.taxSuccess}%
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                    <i
                      className="fa-solid fa-percent"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div> */}
      {/* <div className="col-12 col-sm-4">
          <div className="card card-stats bg-dark mb-4 mb-xl-0 cards-bg">
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Total Pendente
                  </h5>
                  <span className="h2 font-weight-bold mb-0">568,45 €</span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                    <i
                      className="fa-solid fa-money-bill"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div> */}
      {/* </div> */}
      <div className="row mt-5">
        <div className="col-12  mb-3 mb-sm-0">
          <div className="box-venue">
            <TicketsComponent data={data} />
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12">
          <Grid
            ref={gridTicketsListEntriesRef}
            rows={data.list_tickets}
            height="100vh"
            pagination={true}
            cols={[

              { headerName: "Bilhete", field: "ticket_name" },
              { headerName: "Preço", field: "price" },
              { headerName: "Cliente", field: "client_name" },
              { headerName: "Telemovel", field: "client_phone_number" },
              { headerName: "Email", field: "client_email" },
              { headerName: "Contribuinte", field: "client_vat_number" },
              { headerName: "Promotor", field: "promotor_name" },
              {
                headerName: "Check-In", field: "check_in", cellRenderer: (params) => {
                  return (
                    <div className="text-center">
                      {params.data.check_in ? (
                        <i className="fa-solid fa-check text-success"></i>
                      ) : (
                        <i className="fa-solid fa-times text-danger"></i>
                      )}
                    </div>
                  );
                },
              },
              { headerName: "Hora Check-In", cellStyle: { textAlign: 'center' }, field: "check_in_datetime" },
            ]}
          />
        </div>
      </div>
    </div>
  ) : null;
};

export default TicketsStatsView;
